<template>
  <div class="home">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-2 sdbr">
          <Sidebar />
        </div>
        <div class="col-sm-8 txt-grey mt-5">
          <div class="d-flex align-content-between flex-wrap">
            <div class="offset-md-2"></div>
            <div class="col-sm-12 col-md-4 border mbox shdw brdrad py-2">
              <div class="row">
                <div class="col-sm-12 text-center txt-grey py-4">
                  <router-link :to="routeTo">
                    <div class="h4">See Devices</div>
                  </router-link>
                </div>
                <div class="col-sm-12 text-justify">
                  <p>Device admin dashboard to view all customers, devices assigned to them, device status or peform device level crud operations</p>
                </div>
              </div>
            </div>
            <div class="offset-md-2"></div>
            <div class="col-sm-12 col-md-4 border mbox shdw brdrad py-2">
              <div class="row">
                <div class="col-sm-12 text-center txt-grey py-4">
                  <router-link to="/apidb">
                    <div class="h4">See API</div>
                  </router-link>
                </div>
                <div class="col-sm-12 text-justify">
                  <p>Get list of all API users, the monthly calls, API types, user Activity details.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import moment from "moment";
import Sidebar from "../components/sidebar";
export default {
  data(){
    return {
      start : moment().format("DD MM YYYY HH mm"),
      end : moment(),
      routeTo : parseInt(JSON.parse(localStorage.getItem("user")).roleId) == 3 ? '/search' : '/cust'
    }
  },
  name: "Home",
  components: {
    Sidebar,
  },
};
</script>
<style scoped>
.mbox {
  height: 15rem;
}
</style>
